module.exports = __webpack_public_path__ + "static/media/sesaco-logo.0def67ff.jpeg";